/**
 * External dependencies
 */
import React from 'react';

/**
 * Internal dependencies
 */
import Section from 'components/section';
import Main from 'components/main';
import DocumentHead from 'data/document-head';
import AccountPreferences from 'modules/me/account-preferences';
import Navigation from 'modules/me/navigation';

/**
 * Style dependencies
 */
import './styles.scss';

const Account = () => {
    return (
        <Main>
            <DocumentHead title='Account' />
            <Navigation />
             <Section label='Preferences'>
                <AccountPreferences />
            </Section>
        </Main>
    );
};

export default Account;
